import React, {MouseEventHandler} from 'react'
import Dropzone from 'react-dropzone'
import {fileType, maxSize} from '../../../helpers/WizardHelpers'
import { KTSVG } from '../../../../../../../template/_metronic/helpers'

type Props = {
  item?: File
  onDrop: (acceptedFiles: File[]) => void
  onRemoveItem: (event: React.MouseEvent<HTMLElement>) => void
}

const DropBox = ({item, onDrop, onRemoveItem}: Props) => {
  return (
    <>
      {!item ? (
        <Dropzone onDrop={onDrop} multiple={false} accept={fileType} maxSize={maxSize}>
          {({getRootProps, getInputProps}) => (
            <section>
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <div
                  className={`d-flex 'bg-transparent' rounded border border-dashed p-6`}
                  id='kt_inbox_compose_attachments'
                >
                  {/* <i className='bi bi-cloud-upload text-primary bi-5x me-8'></i> */}
                  <KTSVG path='/media/soyfri-media/cloud-arrow-up.svg' className='svg-icon-5x me-8' />
                  <div className='d-flex flex-stack flex-grow-1'>
                    <div>
                      <h4 className='fs-2 text-gray fw-semibold'>
                        Arrastra o haz click para subir tu archivo.
                      </h4>
                      <div className='fs-6 text-primary'>Formato en .xlsx</div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
        </Dropzone>
      ) : (
        <div
          className={`d-flex bg-light-primary border-primary rounded border border-dashed p-6`}
          id='kt_inbox_compose_attachments'
        >
          <div className='d-flex justify-content-center w-100'>
            <div className='card p-9'>
              <a href='#' className='close-button' onClick={onRemoveItem}>
                &#10006;
              </a>
              <div className='d-flex flex-column flex-wrap text-center'>
                <div>
                  <span className='fs-2 fw-semibold text-primary-dark'>{item.size * 0.001}</span>
                  <span className='text-primary-dark fs-2'>{' KB'}</span>
                </div>
                <span className='fs-2 text-primary-dark'>{item.name}</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export {DropBox}
